import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { closeComplementaryProductsDrawer } from "../Actions/ComplementaryProductsDrawer.action.js"
import { translate } from "../Services/translation.js"
import Drawer from "./Drawer/Drawer.js"
import DrawerBody from "./Drawer/Drawer.body.js"
import DrawerFooter from "./Drawer/Drawer.footer.js"
import DrawerHeader from "./Drawer/Drawer.header.js"
import Button from "./Button.jsx"
import { add as addToCart, load as loadCart } from "../Actions/Cart.action.js"
import NumericUpDown from "./NumericUpDown.js"

const ComplementaryProductsDrawer = ({}) => {
    const dispatch = useDispatch()
    const showComplementaryProductsDrawer = useSelector((state) => state.complementaryProducts.showDrawer)
    const addedProduct = useSelector((state) => state.complementaryProducts.addedProduct)
    const complementaryProducts = useSelector((state) => state.complementaryProducts.products)
    const checkoutUrl = useSelector((state) => state.cart.checkoutUrl)

    const addProductToCart = (event, articleNumber, quantity) => {
        const buttonDomNode = event.currentTarget
        const nodeIdToShowNotification = (buttonDomNode.id = Date.now())
        dispatch(addToCart({
            articleNumber,
            quantity,
            nodeIdToShowNotification,
            notificationMessage: translate("tooltip.addedtocart"),
            hash: Date.now()
        })).then(() => {
            dispatch(loadCart())
        })
    }

    const addAllProductsToCart = (event, products) => {
        const buttonDomNode = event.currentTarget
        const nodeIdToShowNotification = (buttonDomNode.id = Date.now())
        products.forEach((product) => {
            const quantity = quantities.find(q => q.id === product.id)?.quantity || product.recommendedQty || 1;
            dispatch(addToCart({ 
                articleNumber: product.id, 
                quantity,
                nodeIdToShowNotification,
                notificationMessage: translate("tooltip.addedalltocart"),
                hash: Date.now()
            })).then(() => {
                dispatch(loadCart())
            })
        })
    }
    const [quantities, setQuantities] = useState([]);

    useEffect(() => {
        if (complementaryProducts?.length) {
            setQuantities(complementaryProducts.map((p) => ({
                id: p.id,
                quantity: p.recommendedQty || 1
            })));
        }
    }, [complementaryProducts]);

    return (
        <>
            <Drawer toggleDrawer={() => dispatch(closeComplementaryProductsDrawer())} showDrawer={showComplementaryProductsDrawer} showButton={false}>
                <Fragment>
                    <div className={`drawer__header h-flex`}>
                        <div className="columns">
                            <div className="complementary-products-drawer__added-to-cart-message">
                                <span className="complementary-products-drawer__check-icon"></span>
                                {`"${addedProduct?.name ?? addedProduct?.id}" ${translate("complementaryProductsDrawer.addedToCart")}`}
                            </div>
                        </div>
                        <div className="columns shrink">
                            <button type="button" className="drawer__close-button" onClick={() => dispatch(closeComplementaryProductsDrawer())}></button>
                        </div>
                    </div>
                    <DrawerBody>
                        <div className="complementary-products-drawer__heading">{translate("complementaryProductsDrawer.heading")}</div>
                        <div className="product-list complementary-products-drawer__product-list">
                            {complementaryProducts?.map((product, index) => (
                                <div key={"product-" + index} className="complementary-products-drawer__product-list-item product-list__item">
                                    <article className="product-card">
                                        <a href={product.productUrl?.replace(/^\//, "")} itemProp="url" title={product.name} className="product-card__link">
                                            <figure className="product__figure">
                                                <img
                                                    className="product__image"
                                                    itemProp="image"
                                                    src={product.imageUrl?.replace(/^\//, "")}
                                                    alt={product.name}
                                                    loading="lazy"
                                                />
                                            </figure>
                                            <div className="product__info">
                                                <h3 itemProp="name" className="product__name">
                                                    {product.name}
                                                </h3>
                                            </div>
                                        </a>
                                        <NumericUpDown
                                            minValue="0"
                                            maxValue={Number.MAX_SAFE_INTEGER}
                                            quantity={quantities.find(q => q.id === product.id)?.quantity || product.recommendedQty || 1}
                                            multiple={product.complementaryAmount || 1}
                                            decimals={0}
                                            initialValue={product.recommendedQty || 1}
                                            onChange={(value) => {
                                                const newQuantities = [...quantities];
                                                const productIndex = newQuantities.findIndex(q => q.id === product.id);
                                                if (productIndex !== -1) {
                                                    newQuantities[productIndex].quantity = value;
                                                    setQuantities(newQuantities);
                                                }
                                            }}
                                            onlyFullPackage={"false"}
                                        />
                                        {product.unitPrice !== 0.0 && 
                                            <>
                                                <div className="complementary-products-drawer__product-price">{(product.unitPrice * (quantities.find(q => q.id === product.id)?.quantity || product.recommendedQty || 1)).toFixed(2)} {product.currency}</div>
                                                <Button disabled={!product.inStock} variant="small" className="complementary-products-drawer__buy-button" onClick={(e) => {
                                                    const quantity = quantities.find(q => q.id === product.id)?.quantity || product.recommendedQty || 1;
                                                    addProductToCart(e, product.id, quantity)
                                                }}>
                                                    {translate("complementaryProductsDrawer.addToCart")}
                                                </Button>
                                            </>
                                        }
                                    </article>
                                </div>
                            ))}
                        </div>
                        <Button variant="full-width" className="complementary-products-drawer__buy-button" onClick={(e) => addAllProductsToCart(e, complementaryProducts)}>
                            {translate("complementaryProductsDrawer.addAllToCart")}
                        </Button>
                    </DrawerBody>
                    <div className="complementary-products-drawer__footer">
                        <button type="button" className="btn btn--outlined btn--full-width " onClick={() => dispatch(closeComplementaryProductsDrawer())}>
                            {translate("complementaryProductsDrawer.continueShopping")}
                        </button>
                        <a href={checkoutUrl} className="btn btn--outlined btn--full-width" onClick={() => dispatch(closeComplementaryProductsDrawer())}>
                            {translate("complementaryProductsDrawer.toCheckout")}
                        </a>
                    </div>
                </Fragment>
            </Drawer>
        </>
    )
}

export default ComplementaryProductsDrawer
